import { ReactComponent as EmptySvg } from "./svgs/empty.svg"

export default EmptySvg
